require('./RAHireManagementPlanStep2.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @components
const RAContributionPeriodicity = require('../../RAContributionPeriodicity/RAContributionPeriodicity');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const CurrencyHelper = require('utilities/currencyHelper');
const { recordProcess } = require('utilities/tagging');

// @constants
const {
    SECOND_STEP,
    DATE_FORMAT_DAY_MONTH_YEAR,
    EURO_SYMBOL,
} = require('constants/index');
const {
    CONTRIBUTION_PERIOD_DAILY,
    CONTRIBUTION_PERIOD_WEEKLY,
    CONTRIBUTION_PERIOD_MONTHLY,
} = require('../../../raConstants/index');

class RAHireManagementPlanStep2 extends React.Component {
    componentWillMount() {
        this.props.validateCalendarStep();
    }

    componentDidMount() {
        const { active } = this.props;
        const customData = {
            event_name: active ? 'step_periodic_contribution' : 'step_product_details',
            pageName: active ? '/contractingRobo/step2/periodicContribution' : '/applicationRobo/step0/prodcutDetails',
            processDetail: active ? 'periodicContribution' : 'productDetails', 
            sectionFamily: 'wealth',
            sectionCategory: 'products',
            sectionName: 'robo',
            serviceType: 'productContracting',
            interactionType: 'funnel',
            processType: active ? 'contractingRobo' : 'applicationRobo',
            processStep: active ? 'step2' : 'step0',
            productName: 'robo',
        };
        recordProcess('', '', customData, true);
    }

    getFechaDeInicio(periodicity, purchaseDate) {
        let fechaDeInicioDate;
        let currentDate = moment();
        const formattedCurrentDate = new Date(
            currentDate.year(),
            currentDate.month(),
            purchaseDate,
        );

        switch (periodicity) {
            case CONTRIBUTION_PERIOD_MONTHLY:
                fechaDeInicioDate = this.deduceDate(
                    purchaseDate,
                    currentDate,
                    formattedCurrentDate,
                );
                break;
            case CONTRIBUTION_PERIOD_WEEKLY:
                fechaDeInicioDate = moment(formattedCurrentDate).add(7, 'day');
                break;
            case CONTRIBUTION_PERIOD_DAILY:
                fechaDeInicioDate = moment(formattedCurrentDate).add(1, 'day');
                break;
            default:
                fechaDeInicioDate = moment();
                break;
        }
        let finalDate = moment(fechaDeInicioDate)
            .format(DATE_FORMAT_DAY_MONTH_YEAR)
            .split('.')
            .join('');
        return finalDate;
    }

    deduceDate(purchaseDate, currentDate, formattedCurrentDate) {
        let fechaInicioDate;
        if (purchaseDate <= currentDate.date()) {
            fechaInicioDate = moment(formattedCurrentDate).add(1, 'month');
        } else {
            fechaInicioDate = formattedCurrentDate;
        }
        return fechaInicioDate;
    }

    buildCalenderSection(immSteps, active) {
        let customSection, selectedPeriodictyLabel;
        const contributionDay = this.getFechaDeInicio(
            immSteps.getIn([SECOND_STEP, 'periodicity']),
            immSteps.getIn([SECOND_STEP, 'contributionDay']),
        );
        const options = [
            {
                label: formatText('raContributionPeriodicity-daily'),
                value: CONTRIBUTION_PERIOD_DAILY,
            },
            {
                label: formatText('raContributionPeriodicity-weekly'),
                value: CONTRIBUTION_PERIOD_WEEKLY,
            },
            {
                label: formatText('raContributionPeriodicity-monthly'),
                value: CONTRIBUTION_PERIOD_MONTHLY,
            },
        ];

        options.map(item => {
            if (immSteps.getIn([SECOND_STEP, 'periodicity']) === item.value) {
                selectedPeriodictyLabel = item.label;
            }
        });

        if (active) {
            const contributionAmount = immSteps.getIn([
                SECOND_STEP,
                'recurringContributionAmount',
            ]);
            const disableSelect = contributionAmount < 1;

            customSection = (
                <div>
                    <FormattedText
                        value="raHireManagementPlanStep2-info"
                        className="ra-hire-management-plan-step2__info"
                    />
                    <div className="ra-hire-management-plan-step2__contribution">
                        <RAContributionPeriodicity
                            amount={contributionAmount}
                            selectedDay={immSteps.getIn([
                                SECOND_STEP,
                                'contributionDay',
                            ])}
                            selectedPeriodicity={immSteps.getIn([
                                SECOND_STEP,
                                'periodicity',
                            ])}
                            errorState={immSteps.getIn([
                                SECOND_STEP,
                                'errorFlags',
                            ])}
                            errorMessage={formatText(
                                'raHireManagementPlanStep2-errorMessage',
                            )}
                            onDayClick={this.props.onContributionDayChange}
                            onPeriodicityChange={this.props.onPeriodicityChange}
                            onRecurringContributionChange={
                                this.props.onRecurringContributionChange
                            }
                            keepZeroAndEmpty={true}
                            disableSelect={disableSelect}
                            hideFocusZero={true}
                        />
                    </div>
                </div>
            );
        } else {
            customSection = (
                <div className="row">
                    <div className="col-md-5">
                        <div className="row">
                            <div className="ra-hire-management-plan-step2__header-section">
                                <div className="ra-hire-management-plan-step2__headersection-col-header print-label">
                                    <FormattedText value="raContributionPeriodicity-contributionAmount" />
                                </div>
                                <div>
                                    <span className="ra-hire-management-plan-step2__headersection-value">
                                        {CurrencyHelper.formatAmount(
                                            immSteps.getIn([
                                                SECOND_STEP,
                                                'recurringContributionAmount',
                                            ]),
                                        )}
                                    </span>{' '}
                                    <span className="ra-hire-management-plan-step2__headersection-value">
                                        {EURO_SYMBOL}
                                    </span>
                                </div>
                            </div>
                            <div className="ra-hire-management-plan-step2__header-section">
                                <div className="ra-hire-management-plan-step2__headersection-col-header print-label">
                                    <FormattedText value="raContributionPeriodicity-selectInfo" />
                                </div>
                                <div>
                                    <span className="ra-hire-management-plan-step2__headersection-value">
                                        {selectedPeriodictyLabel}
                                    </span>
                                </div>
                            </div>
                            <div className="ra-hire-management-plan-step2__header-section">
                                <div className="ra-hire-management-plan-step2__headersection-col-header print-label">
                                    <FormattedText value="raContributionPeriodicity-fechaDeInicio" />
                                </div>
                                <div>
                                    <span className="ra-hire-management-plan-step2__headersection-contribution">
                                        {contributionDay}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7" />
                </div>
            );
        }
        return customSection;
    }

    render() {
        const { immSteps, active } = this.props;
        let section = this.buildCalenderSection(immSteps, active);

        return (
            <div className="ra-hire-management-plan-step2">
                <div className="row">
                    <div className="col-md-12">{section}</div>
                </div>
            </div>
        );
    }
}

RAHireManagementPlanStep2.propTypes = {
    active: PropTypes.bool.isRequired,
    immSteps: PropTypes.object.isRequired,
    onAccountChange: PropTypes.func.isRequired,
    onContributionDayChange: PropTypes.func.isRequired,
    onPeriodicityChange: PropTypes.func.isRequired,
    onRecurringContributionChange: PropTypes.func.isRequired,
    validateCalendarStep: PropTypes.func.isRequired,
};

module.exports = RAHireManagementPlanStep2;
